<script>
import {mapGetters} from 'vuex'
import List from '../../../mixins/list/list'

export default {
    name: 'archived-offers',
    mixins:[List],
    computed: 
    {
        ...mapGetters({
            items: 'offersArchived'
        }),
    },
    data()
    {
        return {
            action: 
            {
                fetch: 'offersFetchArchived',
                reorder: 'offerReorder'
            },
            id: 'offer_id',
            subPageName: 'offers-subpages',
        }
    },
}
</script>

<template lang="html">
    <div>
        <recover-modal ref="recoverSingleModal" noButton @fetch="fetch" :items="selectedHelper" type="offerAction"></recover-modal>
        <div class="py-2 px-2 row">
            <div class="col">
                <custom-button iconBeforeText="fal fa-arrow-to-bottom fa-xs mr-2" text="Export data" @buttonClick="export_all"></custom-button>
            </div>
            <div class="col-2">
                <channel-filter>

                </channel-filter>
            </div>
            <div class="float-right col-2">
                <simple-input type="text" noRadius v-model="search" icon="fal fa-search" placeholder="Search"></simple-input>
            </div>
        </div>
        <table class="engage-table" v-if="items.data && items.data.length != 0">
            <thead>
                <tr>
                    <th class="pl-3 pr-2 w-40px">
                        <choice-input type="checkbox" v-model="all_selected"></choice-input>
                    </th>
                    <th></th>
                    <order-column field='id'>
                        ID
                    </order-column>
                    <order-column field='name'>
                        Offer
                    </order-column>
                    <th>Channel</th>
                    <order-column field='expires_at'>
                        Expired
                    </order-column>
                    <th class="text-right">Revenue</th>
                    <th class="text-right">Profit</th>
                    <th class="text-right">ROI</th>
                    <th class="text-center">
                        <i class="fal fa-chart-area"></i>
                    </th>
                    <th class="text-center">
                        <i class="far fa-globe"></i>
                    </th>
                </tr>
            </thead>
            <tbody v-if="items && items.data">
                <tr v-for="(offer,index) in items.data" :key="offer.id">
                    <td class="pl-3 pr-2">
                        <choice-input type="checkbox" v-if="selected[index]" v-model="selected[index].selected"></choice-input>
                    </td>
                    <td>
                        <template v-if="offer.desktop_images && offer.desktop_images[0]">
                            <img class="table-img" :src="offer.desktop_images[0].display_url" alt="Desktop">
                        </template>
                    </td>
                    <td class="cp">
                        <router-link :to="{name:'offer-edit', params: {item: offer.id, slug: 'creative'}}">
                            #{{ offer.offer_id }}
                        </router-link>
                    </td>
                    <td class="font-weight-bold cp">
                        <router-link :to="{name:'offer-edit', params: {item: offer.id, slug: 'creative'}}">
                            {{ offer.name }}
                        </router-link>
                    </td>
                    <td>
                        <template v-if="offer.client && offer.client.name">
                            <span>
                            {{ offer.client.name }}
                            </span>
                        </template>
                    </td>
                    <td>
                        <template v-if="offer.expires_at">
                            {{ offer.expires_at | toDate }}
                        </template>
                    </td>
                    <td class="text-right">
                        ${{ offer.revenue | toMoney }}
                    </td>
                    <td class="text-right">
                        ${{ offer.profit | toMoney }}
                    </td>
                    <td class="text-right">
                        ${{ offer.roi }}
                    </td>
                    <td @click="export_item(offer)" class="text-center cp user-none">
                        <i class="fal fa-arrow-to-bottom"></i>
                    </td>
                    <td class="text-center cp user-none">
                        <i @click="recover(offer)" class="fal fa-redo"></i>
                    </td>
                </tr>

            </tbody>
        </table>
        <div v-else class="px-2 py-4">
            <smile-with-text header="No Archived Offers yet" text="There are no offers here" faType="fal" icon="frown"></smile-with-text>
        </div>
        <paginator :items="items" :subPageName="subPageName" :loading="loading"></paginator>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/offers/subpages/Archived.vue